<template>
<div class="chapter">
<div class="inner_page">
<div class="generated-style" id="fm-08-typesofpops-text">
<p class="top-bar" xml:lang="en-us"><span class="generated-style-2"><img alt="IcePops_TopBar_Pink.gif" class="generated-style-2" src="Images/IcePops_TopBar_Pink_fmt.jpeg"/></span></p>
<h2 class="recipe-heading" id="toc-anchor" xml:lang="en-us">types of pops</h2>
<p class="body-copy" xml:lang="en-us">You’ll discover many types of ice pops in this book, from fruit-focused to decidedly decadent. After you try a few, take the recipes as inspiration, mixing and matching flavors, playing with layers, and creating your own combinations.</p>
<p class="method-subhead" xml:lang="en-us">fruity pops</p>
<p class="body-copy" xml:lang="en-us">Perhaps the most familiar type, fruity pops start with ripe, fresh, in-season fruit, which is puréed in a blender or food processor or squeezed with a citrus juicer. Sugar and flavorings are added to create a sorbet-like base, then the mixture is poured into molds and frozen until firm.</p>
<p class="method-subhead" xml:lang="en-us">chocolate pops</p>
<p class="body-copy" xml:lang="en-us">Chocolate ice pops are created in two main ways: either by dissolving cocoa powder into a dairy base, or by incorporating melted chocolate with an egg-rich custard. Both methods yield intensely chocolately frozen treats.</p>
<p class="method-subhead" xml:lang="en-us">creamy pops</p>
<p class="body-copy" xml:lang="en-us">Rich, smooth, ice cream–inspired pops start with either a custard, as with churned ice cream, or a mixture of yogurt, condensed milk, or other creamy dairy product. A variety of flavorings can be combined with the base to create a smooth, layered, or even chunky texture.</p>
<p class="method-subhead" xml:lang="en-us">new-flavored pops</p>
<p class="body-copy" xml:lang="en-us">In contrast to the classic tastes featured in the earlier chapters, these recipes offer innovative—and often unexpected—flavor combinations using such ingredients as fresh herbs, exotic spices, and flavorful liquids. Some flavors, such as the liquor-infused pops, are best suited for adult palates.</p>
<p class="bottom-bar" xml:lang="en-us"><span class="generated-style-2"><img alt="IcePops_TopBar_Pink.gif" class="generated-style-2" src="Images/IcePops_TopBar_Pink_fmt1.jpeg"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FM_08_TypesOfPops_text.vue?18063ebf